/**
 * HomePage Header Component
 * Displays welcome message and greeting based on time of day
 */

import { Typography, Paper, Box, Fade } from "@mui/material";

const HomePageHeader = ({ greeting, userName, hasApplications }) => {
  return (
    <Fade in timeout={800}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          p: { xs: 3, sm: 4 },
          mb: 4,
          background: "#ffffff",
          position: "relative",
          border: "1px solid rgba(0,0,0,0.08)",
          boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)",
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              variant="h3"
              fontWeight="bold"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2.5rem" },
                mb: 1,
                color: "#1f2937",
              }}
            >
              {userName ? `${greeting}, ${userName}` : "ברוכים הבאים!"}
            </Typography>
            {hasApplications && (
              <Typography
                sx={{
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  color: "#6b7280",
                  fontWeight: 400,
                }}
              >
                {userName
                  ? "בחר את האפליקציה הרצויה"
                  : "אנא התחבר לחשבון שלך על מנת להמשיך"}
              </Typography>
            )}
          </Box>
        </Box>
      </Paper>
    </Fade>
  );
};

export default HomePageHeader;
